module.exports = __webpack_public_path__ + "static/media/hotel.142cd6f3.jpg";